import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatLine from "./ChatLine";
import StarRating from "./StarRating"; // import TranscriptDownload from '../resources/TranscriptDownload.png';
// import { GET_CHAT_TRANSCRIPT } from "../constants/endpoints";

import RatingExtraMileIcon from "../resources/rate-extra-mile.png";
import RatingFriendlyIcon from "../resources/rate-friendly.png";
import RatingKnowledgeIcon from "../resources/rate-knowledge.png";
import RatingNegSmile from "../resources/NegSmile.png";
import RatingNegIncorrect from "../resources/NegIncorrect.png";
import RatingNegInfo from "../resources/NegInfo.png";

class RatingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      rating: 0,
      notes: ""
    };
    this.ratingSet = this.ratingSet.bind(this);
    this.notesSet = this.notesSet.bind(this);
    this.ratingSubmit = this.ratingSubmit.bind(this);
    this.ratingSkip = this.ratingSkip.bind(this);
  }

  ratingSet(value) {
    let currentStep = 2;

    if (value > 5) {
      currentStep = 1;
      setTimeout(() => {
        this.ratingSubmit();
      }, 0);
    }

    this.setState({
      step: currentStep,
      rating: value,
      notes: ""
    });
  }

  notesSet(value, custom = false) {
    this.setState({
      notes: value,
      custom
    });
  }

  ratingSubmit() {
    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      this.props.onSubmit(this.state.rating, this.state.notes);
    }, 100);
  }

  ratingSkip() {
    this.props.onSkip();
  }

  render() {
    const endMessage = {
      messages: ["Thank you for getting in touch."],
      source: "dpd"
    };
    let selectables = [["Knowledgeable", RatingKnowledgeIcon], ["Went the extra mile", RatingExtraMileIcon], ["Friendly manner", RatingFriendlyIcon]];

    if (this.state.rating <= 2) {
      selectables = [["Advisor wasn't helpful", RatingNegSmile], ["Didn't keep me updated", RatingNegInfo], ["Incorrect information", RatingNegIncorrect]];
    }

    return /*#__PURE__*/React.createElement("div", {
      id: "chat-view",
      className: "rating-view"
    }, /*#__PURE__*/React.createElement("div", null, this.state.step === 1 ? /*#__PURE__*/React.createElement(ChatLine, {
      message: endMessage
    }) : null, /*#__PURE__*/React.createElement("h4", {
      className: "rating-header"
    }, "Rate this chat experience"), /*#__PURE__*/React.createElement(StarRating, {
      onChange: this.ratingSet
    }), this.state.step === 2 ? /*#__PURE__*/React.createElement("div", {
      id: "text-rating-block"
    }, this.state.rating <= 2 ? /*#__PURE__*/React.createElement("span", null, "Oh no, please tell us why you feel this way") : /*#__PURE__*/React.createElement("span", null, "Please tell us what your advisor did best"), /*#__PURE__*/React.createElement("div", {
      className: "preset-rating-line"
    }, selectables.map((review, index) => /*#__PURE__*/React.createElement("div", {
      className: "preset-rating",
      onClick: () => {
        this.notesSet(review[0]);
      },
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: `preset-rating-circle ${this.state.notes === review[0] ? "active" : ""}`
    }, /*#__PURE__*/React.createElement("img", {
      src: review[1],
      alt: "Rating circle"
    })), /*#__PURE__*/React.createElement("div", {
      className: "preset-rating-text"
    }, review[0])))), /*#__PURE__*/React.createElement("input", {
      className: "rating-input",
      type: "text",
      placeholder: "Something else",
      value: this.state.custom ? this.state.notes : "",
      onChange: e => {
        this.notesSet(e.target.value, true);
      }
    })) : null, this.state.step === 2 ? /*#__PURE__*/React.createElement("div", {
      id: "submit-rating"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.ratingSubmit
    }, "Submit")) : null, this.state.step === 1 ? /*#__PURE__*/React.createElement("div", {
      id: "skip-rating"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.ratingSkip
    }, "Skip")) : null));
  }

}

RatingView.propTypes = {
  onSkip: PropTypes.func,
  onSubmit: PropTypes.func
};
export default RatingView;